/**
 * Event Library
 *
 * Throws global events for initializing your javascript code:
 *
 * Events:
 *  - Creaton.Experts.initialize:    Gets called whenever an entire page got rendered in backend and frontend
 *  - Creaton.Experts.apiInitialized The api of currently google got initialized(gets only triggered if a map is on the current dom
 *
 * @module Event
 */
;(function Event() {
    var apiAdded = false

    function ready(fn) {
        if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
            fn()
        } else {
            document.addEventListener('DOMContentLoaded', fn)
        }
    }

    /**
     * Event: Creaton.Experts.initialize
     */
    function initialize() {
        if (typeof CustomEvent === 'function') {
            document.dispatchEvent(new CustomEvent('Creaton.Experts.initialize'))
        } else if (typeof document.createEvent === 'function') {
            /* older browsers need this to create, init and dispatch the event */
            var event = document.createEvent('CustomEvent')
            event.initCustomEvent('Creaton.Experts.initialize', true, true, {})
            document.dispatchEvent(event)
        }
    }

    if (typeof document.addEventListener === 'function') {
        document.addEventListener(
            'Neos.PageLoaded',
            function (event) {
                initialize()
            },
            false
        )
    }

    if (typeof document.addEventListener === 'function') {
        document.addEventListener(
            'Creaton.Experts.initialize',
            function (event) {
                if (!apiAdded) {
                    if (document.querySelectorAll('[data-expert="map"]').length > 0) {
                        var s = document.createElement('script')
                        s.type = 'text/javascript'
                        s.src =
                            'https://maps.googleapis.com/maps/api/js?key=' +
                            window.googleMapApiKey +
                            '&libraries=places&callback=initializedExpertsMap'
                        document.head.appendChild(s)
                        apiAdded = true
                    }
                } else {
                    window.initializedExpertsMap()
                }
            },
            false
        )
    }

    /**
     * Event: Creaton.Experts.apiInitialized
     */
    window.initializedExpertsMap = function () {
        if (typeof CustomEvent === 'function') {
            document.dispatchEvent(new CustomEvent('Creaton.Experts.apiInitialized'))
        } else if (typeof document.createEvent === 'function') {
            /* older browsers need this to create, init and dispatch the event */
            var event = document.createEvent('CustomEvent')
            event.initCustomEvent('Creaton.Experts.apiInitialized', true, true, {})
            document.dispatchEvent(event)
        }
    }

    ready(initialize)
})()
